import gql from 'graphql-tag';

const LOGIN_QUERY = gql`
  query($input: LoginInput) {
    loginAdmin(input: $input) {
      _id
      email
      name
      nickname
      avatar
      accountType
      company
      companies
      union
      influencer
      token
      package
    }
  }
`;

const LOGIN_SSO = gql`
  query($input: LoginSSOInput) {
    loginSSO(input: $input) {
      _id
      email
      name
      nickname
      avatar
      accountType
      company
      companies
      union
      influencer
      token
      package
    }
  }
`;

const MUTATION_CHECK_ACCOUNT = gql`
  mutation($username: String!) {
    checkExistAccount(username: $username)
  }
`;

const MUTATION_FORGOT_PASSWORD = gql`
  mutation($username: String!) {
    forgotPasswordAccount(username: $username)
  }
`;

const MUTATION_REGISTER_ACCOUNT = gql`
  mutation($input: RegisterAdminInput!) {
    registerAccountAdmin(input: $input) {
      _id
    }
  }
`;

const MUTATION_SET_PASSWORD = gql`
  mutation($resetPWdUUID: String!, $password: String!) {
    resetPasswordAccount(resetPWdUUID: $resetPWdUUID, password: $password)
  }
`;

const LoginGRAPHQL = {
  LOGIN_QUERY,
  LOGIN_SSO,
  MUTATION_CHECK_ACCOUNT,
  MUTATION_FORGOT_PASSWORD,
  MUTATION_REGISTER_ACCOUNT,
  MUTATION_SET_PASSWORD
};

export default LoginGRAPHQL;
